/**
 * api-文章栏目
 */
import { post } from '@/utils/http'
// 获取banner列表
export const apiGetBBannerList = p => post('/Bbanner/getBBannerList.do', p)
// 新增banner
export const apiAddBBanner = p => post('/Bbanner/addBBanner.do', p)
// 修改banner
export const apiEditBBanner = p => post('/Bbanner/editBBanner.do', p)
// 删除banner
export const apiDelBBannerList = p => post('/Bbanner/delBBanner.do', p)
